import { Component } from 'react'

// The one place a render error lands. Without it React unmounts the whole
// tree and the page goes blank with nothing to read; with it, the person
// sees what happened and a way back, and the message is there to report.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    // The console is where the stack is useful; the page shows the message.
    console.error(error, info?.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    const error = this.state.error
    // The message plus the first frames of the stack: enough to find the
    // line when it is reported, without a wall of text.
    const message = [error?.message || String(error), ...(error?.stack || '').split('\n').slice(1, 4)]
      .join('\n')
      .trim()
    return (
      <main
        className="w-full px-4 md:w-[85%] md:mx-auto md:px-0"
        style={{ paddingTop: 'var(--space-l)', paddingBottom: 'var(--space-2xl)' }}
      >
        <div className="alert alert--error" role="alert">
          <div className="flex flex-col" style={{ gap: 'var(--space-xs)' }}>
            <p className="text-body-md">Something went wrong on this page.</p>
            <pre className="md-pre" style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>
              {message}
            </pre>
            <div>
              <button
                type="button"
                className="btn btn--secondary btn--sm"
                onClick={() => window.location.reload()}
              >
                Reload the page
              </button>
            </div>
          </div>
        </div>
      </main>
    )
  }
}
